/**
 * Gender resolution logic for a sociogram survey, extracted from
 * components/SociogramDashboard/networkComponent/inner-network-component.jsx so it can be reused
 * outside the results dashboard (course-assignment's gender export). Same hardcoded question/
 * answer ids as that component - see its own "TODO: sacar todos los questionIds en duro" comment.
 * This is fragile by construction: an unlisted template returns no genderQuestionId, and an
 * unlisted answerId falls through to 'No Info'.
 */
export const GENDER_QUESTION_ID_BY_TEMPLATE = {
  Plantilla_ES_genero_simple: 75,
  Plantilla_ES_v2: 35,
  Template_EN_v2: 55
}

export const resolveGenderQuestionId = (templateName) => GENDER_QUESTION_ID_BY_TEMPLATE[templateName] || null

export const resolveGenderLabel = (answerId) => {
  if ([209, 288, 376].includes(answerId)) return 'Female'
  if ([210, 289, 377].includes(answerId)) return 'Male'
  if ([211, 290].includes(answerId)) return 'Other'
  if (answerId === 369) return 'Non-Binary'
  if ([212, 291].includes(answerId)) return 'None'
  return 'No Info'
}

// course-generator's own sample data uses "H" (Hombre) / "M" (Mujer) - only these two map;
// anything else (Other/Non-Binary/None/No Info/unanswered) is left blank for manual completion.
const GENDER_LABEL_TO_LEGACY_CODE = {
  Male: 'H',
  Female: 'M'
}

export const resolveLegacyGenderCode = (answerId) => GENDER_LABEL_TO_LEGACY_CODE[resolveGenderLabel(answerId)] || ''
